module.exports = __webpack_public_path__ + "static/media/GU.79e42015.svg";